import React, { createContext, useState, useEffect, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, setCookie, deleteCookie } from '../../services/DataRequestService';
import { getValue, setValue } from '../../Utils/helper';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState(() => {
    // Load initial data from sessionStorage if available

    let _formData = getValue('session', 'formData');

    if (!_formData) {
      resetFormData();
    } else {
      const isReset = window.confirm('Do you need to reset existing Workflow ?');
      if (isReset) {
        resetFormData();
      } else {
        //do nothing
      }
    }
    let savedData = sessionStorage.getItem('formData');
    return savedData ? JSON.parse(savedData) : null;
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Save formData to sessionStorage on change
    sessionStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);

  const updateFormData = (tabName, data) => {
    setFormData((prev) => ({ ...prev, [tabName]: data }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData, errors, setErrors }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);

export const resetFormData = () => {

  sessionStorage.clear('formData')
  let id = uuidv4();
  //let id = 'bd7c3e51-2e06-42ac-80ae-82157c5f467121';
  let form = {
    id: id,
    object: "WorkflowForm",
    user_id: getCookie('sub'),
    email_id: getCookie('email'),
    full_name: getCookie('name'),
    stage1: {
      file_upload_status: { 0: null, 1: null, 2: null, 3: null },
      data_upload_id: null,
      file_upload_option: null
    },
    stage2: {
      start_date: null,
      end_date: null,
      train_percentage: 80,
      test_percentage: 20,
      data_frequency: null,
      forecast_frequency: null,
      forecast_period: null,
      product_category:null
    },
    stage3: null,
    stage4: { combinations:[] },
    stage5: {file_upload_status : null , seasonality_data : [] },
    stage6: null,
    stage7: null
  };
  setValue('session', 'formData', null, form);
}